export const USERS_FETCH = 'USERS_FETCH';
export const USERS_FETCH_COMPLETED = 'USERS_FETCH_COMPLETED';
export const USERS_FETCH_FAILED = 'USERS_FETCH_FAILED';
export const USERS_STARTING_ELEMENTS_PER_PAGE = 10;
export const USERS_ELEMENTS_PER_PAGE_OPTIONS = [10, 25, 50];
export const USERS_PER_PAGE_LIMIT = 'USERS_PER_PAGE_LIMIT';
